import { ref } from 'config/constants'
import { showMessage } from 'data/messages/actions';
import {
    FETCH_CAMPAIGNS,
    FETCH_CAMPAIGNS_SUCCESS,
    UPDATE_CAMPAIGN,
    
} from './types';
import { OrderStatus } from 'data/orders/types';

const Campaigns = ref.child("campaigns");

/* Pampaign */
export function fetchCampaigns(accountid) {
    return dispatch => {
        dispatch({
            type: FETCH_CAMPAIGNS,
            payload: { pending: true }
        });
        Campaigns.child(accountid).on('value', snapshot => {
            dispatch({
                type: FETCH_CAMPAIGNS_SUCCESS,
                payload: snapshot.val()
            });
        });
    };
}

export function createCampaign(accountid, campaign, handleClick) {
    campaign.accountid = accountid;
    campaign.created = new Date().getTime();
    campaign.updated = new Date().getTime();
    return dispatch => Campaigns.child(accountid).push({details: campaign}).then( (snapshot) => { 
        if (typeof handleClick !== 'undefined')
        {
            handleClick(snapshot.key)
        }
    })
}

export function deleteCampaign(accountid, key) {
    return dispatch => Campaigns.child(accountid).child(key).remove().
                                 then( 
                                     dispatch(showMessage(`Kampanjen har raderats.`) )
                                 ).
                                 catch( (error) => {
                                     dispatch(showMessage(error.message) )
                                 });
}

export function updateCampaign(accountid, key, campaign) {

    campaign.updated = new Date().getTime();

    return dispatch => {

        dispatch({type: UPDATE_CAMPAIGN, payload: { pending : true } })

        return Campaigns.child(campaign.accountid).child(key).child("details").set(campaign).
                         then( () => {
                             dispatch(showMessage(`"${campaign.name}" är uppdaterad.`) )
                         }).
                         catch( (error) => {
                             dispatch(showMessage(error.message) )
                         }).
                         then( () => {
                             dispatch({type: UPDATE_CAMPAIGN, payload: { pending : false } })
                         })
    }
}


export function addToCampaign(accountid, key, item, campaign, product) {

  item.accountid = accountid;
  item.campaignid = key;
  return dispatch => { 

     dispatch({type: UPDATE_CAMPAIGN, payload: { pending : true } })

    return Campaigns.child(accountid).child(key).child("bookings").push(item).
        then( () => {
            const msg = `"${product.name}" har lagts till "${campaign.details.name}"`
            dispatch(showMessage(msg) )
        }).
        catch( (error) => {
            dispatch(showMessage(error.message) )
        }).
        then( () => {
            dispatch({type: UPDATE_CAMPAIGN, payload: { pending : false } })
        });
  }
}

export function removeFromCampaign(accountid, campaignid, itemid) {
  return dispatch => Campaigns.child(accountid).child(campaignid).child("bookings").child(itemid).remove();
}



// WEBPACK FOOTER //
// ./src/data/campaigns/actions.js